module.exports = __webpack_public_path__ + "5cc7b346231f221dc2838a083ca1e3e4.png";